// HoC mini-cart overlay logic – LV-tyylinen mini-cart

(function () {
  var overlay = document.getElementById('HocMiniCartOverlay');
  if (!overlay) return;

  var itemsContainer = overlay.querySelector('[data-hoc-mini-cart-items]');
  var countEl = overlay.querySelector('[data-hoc-mini-cart-count]');
  var totalEl = overlay.querySelector('[data-hoc-mini-cart-total]');
  var checkoutBtn = overlay.querySelector('[data-hoc-mini-cart-checkout]');
  var closeTriggers = overlay.querySelectorAll('[data-hoc-mini-cart-close]');

  var MAX_QTY = 20;

  /* ========== HEADERIN KORKEUS → overlay alkaa sen alta ========== */

  function setHeaderOffset() {
    var header =
      document.getElementById('Header-group') ||
      document.getElementById('shopify-section-header');
    if (!header) return;
    var h = header.offsetHeight || 0;
    document.documentElement.style.setProperty(
      '--hoc-header-offset',
      h + 'px'
    );
  }

  setHeaderOffset();
  window.addEventListener('resize', setHeaderOffset);

  /* ========== APUMETODIT ========== */

  // Roskakori-ikonin SVG
  var trashIconSvg =
    '<svg class="hoc-mini-cart__trash-svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<rect x="4" y="5" width="8" height="9" rx="1" fill="none" stroke="currentColor" stroke-width="1.2"/>' +
    '<path d="M3 5h10" fill="none" stroke="currentColor" stroke-width="1.2"/>' +
    '<path d="M6 3h4" fill="none" stroke="currentColor" stroke-width="1.2"/>' +
    '<path d="M7 7v5M9 7v5" fill="none" stroke="currentColor" stroke-width="1.2"/>' +
    '</svg>';

  // Hinta muodossa "€ 490"
  function formatMoney(cents) {
    var euros = Math.round(cents / 100);
    return '€ ' + euros;
  }

  // Yleinen numero-fade
  function animateNumber(el, newText) {
    if (!el) return;

    el.classList.remove('hoc-mini-cart__number--fade-in');
    el.classList.add('hoc-mini-cart__number--fade-out');

    setTimeout(function () {
      el.textContent = newText;
      el.classList.remove('hoc-mini-cart__number--fade-out');
      el.classList.add('hoc-mini-cart__number--fade-in');

      setTimeout(function () {
        el.classList.remove('hoc-mini-cart__number--fade-in');
      }, 200);
    }, 90);
  }

  /* ========== RENDERÖINTI ========== */

  function renderEmptyCart() {
    itemsContainer.innerHTML = '<p>Ostoskorisi on tyhjä.</p>';
    animateNumber(countEl, '0');
    animateNumber(totalEl, formatMoney(0));

    if (checkoutBtn) {
      checkoutBtn.textContent = 'Jatka selaamista';
      checkoutBtn.setAttribute('data-empty-cart', 'true');
    }
  }

  function buildItemHtml(item) {
    var imageHtml = item.image
      ? '<div class="hoc-mini-cart__image"><img src="' +
        item.image +
        '" alt="' +
        (item.product_title || '') +
        '"></div>'
      : '';

    var subtitle =
      item.variant_title && item.variant_title !== 'Default Title'
        ? item.variant_title
        : '';

    var key = item.key || '';
    var isSingle = item.quantity === 1;
    var minusExtraClass = isSingle ? ' hoc-mini-cart__qty-btn--delete' : '';
    var minusLabel = isSingle ? 'Poista tuote' : 'Vähennä määrä';
    var minusContent = isSingle ? trashIconSvg : '−';

    var plusDisabled = item.quantity >= MAX_QTY;
    var plusDisabledAttr = plusDisabled ? ' disabled="disabled"' : '';
    var plusDisabledClass = plusDisabled
      ? ' hoc-mini-cart__qty-btn--disabled'
      : '';

    return (
      '<article class="hoc-mini-cart__item">' +
      imageHtml +
      '<div class="hoc-mini-cart__details">' +
      '<h3 class="hoc-mini-cart__item-title">' +
      (item.product_title || item.title || '') +
      '</h3>' +
      (subtitle
        ? '<p class="hoc-mini-cart__item-subtitle">' + subtitle + '</p>'
        : '') +
      '<div class="hoc-mini-cart__item-meta">' +
      '<div class="hoc-mini-cart__qty-control" data-line-key="' +
      key +
      '">' +
      '<button type="button" class="hoc-mini-cart__qty-btn' +
      minusExtraClass +
      '" data-qty-direction="minus" aria-label="' +
      minusLabel +
      '">' +
      minusContent +
      '</button>' +
      '<span class="hoc-mini-cart__qty-value hoc-mini-cart__number">' +
      item.quantity +
      '</span>' +
      '<button type="button" class="hoc-mini-cart__qty-btn' +
      plusDisabledClass +
      '" data-qty-direction="plus" aria-label="Lisää määrä"' +
      plusDisabledAttr +
      '>+</button>' +
      '</div>' +
      '<span class="hoc-mini-cart__item-price hoc-mini-cart__number">' +
      formatMoney(item.line_price) +
      '</span>' +
      '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function renderCartInitial(cart) {
    if (!cart.items || !cart.items.length) {
      renderEmptyCart();
      return;
    }

    animateNumber(countEl, String(cart.item_count));
    animateNumber(totalEl, formatMoney(cart.total_price));

    if (checkoutBtn) {
      checkoutBtn.textContent = 'Siirry kassalle';
      checkoutBtn.removeAttribute('data-empty-cart');
    }

    var html = cart.items.map(buildItemHtml).join('');
    itemsContainer.innerHTML = html;
    attachQuantityHandlers();
  }

  /* ========== MÄÄRÄN MUUTTAMINEN (vain +/- napit) =========== */

  function attachQuantityHandlers() {
    var buttons = itemsContainer.querySelectorAll('.hoc-mini-cart__qty-btn');
    buttons.forEach(function (button) {
      button.addEventListener('click', onQtyButtonClick);
    });
  }

  function onQtyButtonClick(event) {
    var button = event.currentTarget;
    if (button.disabled) return;

    var direction = button.getAttribute('data-qty-direction');
    var control = button.closest('.hoc-mini-cart__qty-control');
    if (!control) return;

    var key = control.getAttribute('data-line-key');
    var valueEl = control.querySelector('.hoc-mini-cart__qty-value');
    if (!valueEl) return;

    var currentQty = parseInt(valueEl.textContent, 10);
    if (isNaN(currentQty)) currentQty = 1;

    if (direction === 'plus' && currentQty >= MAX_QTY) {
      return;
    }

    var newQty = direction === 'plus' ? currentQty + 1 : currentQty - 1;
    if (newQty < 0) newQty = 0;

    updateCartLineQuantity(key, newQty);
  }

  function updateCartLineQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Change cart failed');
        return response.json();
      })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          renderEmptyCart();
          return;
        }

        animateNumber(countEl, String(cart.item_count));
        animateNumber(totalEl, formatMoney(cart.total_price));

        if (checkoutBtn) {
          checkoutBtn.textContent = 'Siirry kassalle';
          checkoutBtn.removeAttribute('data-empty-cart');
        }

        var changedItem = cart.items.find(function (item) {
          return item.key === key;
        });

        if (!changedItem) {
          renderCartInitial(cart);
          return;
        }

        var control = itemsContainer.querySelector(
          '.hoc-mini-cart__qty-control[data-line-key="' + key + '"]'
        );
        if (!control) {
          renderCartInitial(cart);
          return;
        }

        var valueEl = control.querySelector('.hoc-mini-cart__qty-value');
        var meta = control.parentElement;
        var priceEl = meta.querySelector('.hoc-mini-cart__item-price');
        var minusBtn = control.querySelector(
          '.hoc-mini-cart__qty-btn[data-qty-direction="minus"]'
        );
        var plusBtn = control.querySelector(
          '.hoc-mini-cart__qty-btn[data-qty-direction="plus"]'
        );

        if (minusBtn) {
          if (changedItem.quantity <= 1) {
            minusBtn.innerHTML = trashIconSvg;
            minusBtn.classList.add('hoc-mini-cart__qty-btn--delete');
            minusBtn.setAttribute('aria-label', 'Poista tuote');
          } else {
            minusBtn.textContent = '−';
            minusBtn.classList.remove('hoc-mini-cart__qty-btn--delete');
            minusBtn.setAttribute('aria-label', 'Vähennä määrä');
          }
        }

        if (plusBtn) {
          if (changedItem.quantity >= MAX_QTY) {
            plusBtn.disabled = true;
            plusBtn.classList.add('hoc-mini-cart__qty-btn--disabled');
          } else {
            plusBtn.disabled = false;
            plusBtn.classList.remove('hoc-mini-cart__qty-btn--disabled');
          }
        }

        animateNumber(valueEl, String(changedItem.quantity));
        animateNumber(priceEl, formatMoney(changedItem.line_price));
      })
      .catch(function (error) {
        console.error('HOC mini-cart: change quantity failed', error);
      });
  }

  /* ========== OVERLAY AVAUS / SULKU ========== */

  function openOverlay() {
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.classList.add('hoc-mini-cart-open');
  }

  function closeOverlay() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.classList.remove('hoc-mini-cart-open');
  }

  closeTriggers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeOverlay();
    });
  });

  overlay.addEventListener('click', function (event) {
    if (
      event.target === overlay ||
      event.target.classList.contains('hoc-mini-cart-backdrop')
    ) {
      closeOverlay();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeOverlay();
    }
  });

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      if (checkoutBtn.getAttribute('data-empty-cart') === 'true') {
        closeOverlay();
      } else {
        window.location.href = '/checkout';
      }
    });
  }

  /* ========== LISÄÄ KORIIN → AVAA MINI-CART ========== */

  function fetchCartAndOpen() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        renderCartInitial(cart);
        openOverlay();
      })
      .catch(function (error) {
        console.error('HOC mini-cart: cart fetch failed', error);
        window.location.href = '/cart';
      });
  }

  function interceptAddToCart(form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          fetchCartAndOpen();
        })
        .catch(function (error) {
          console.error(
            'HOC mini-cart: falling back to default cart behaviour',
            error
          );
          form.submit();
        });
    });
  }

  var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(function (form) {
    interceptAddToCart(form);
  });
})();
